import { LayoutDashboard, Building2, Settings, BarChart, Calculator } from "lucide-react";
import { UserRole } from "../types/auth/auth.types";

export interface NavItem {
  titleKey: string;
  icon: React.ElementType;
  href: string;
  roles: UserRole[];
}

export const getNavItems = (role?: UserRole): NavItem[] => {
  const allItems: NavItem[] = [
    {
      titleKey: "navigation.dashboard",
      icon: LayoutDashboard,
      href: "/",
      roles: ["assimagra", "company", "get2c"],
    },
    {
      titleKey: "navigation.companies",
      icon: Building2,
      href: "/companies",
      roles: ["assimagra", "get2c"],
    },
    {
      titleKey: "navigation.setup",
      icon: Settings,
      href: "/setup",
      roles: ["assimagra", "get2c"],
    },
    {
      titleKey: "navigation.footprints",
      icon: Calculator,
      href: "/footprints",
      roles: ["company"],
    },
    {
      titleKey: "navigation.results",
      icon: BarChart,
      href: "/results",
      roles: ["company"],
    },
  ];

  return role ? allItems.filter((item) => item.roles.includes(role)) : [];
};
